// App Message Posting Function
import snAnalyticsService from '../../../services/snAnalyticsService'
export default {
  methods: {
    postInternalPageView (path) {
      if (window.ga) {
        const pagePath = path.replace(/[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}/ig, 'guid')
        if (!this.$store?.internalGoogleAnalyticsId) {
          snAnalyticsService.getInternalId().then(({ data }) => {
            window.ga(`${data?.analyticsId}.send`, 'pageview', pagePath)
          })
        } else {
          window.ga(`${this.$store.internalGoogleAnalyticsId}.send`, 'pageview', pagePath)
        }
      }
    },
    postInternalGAEvent (group, eventName, label = '') {
      if (window.ga) {
        if (!this.$store?.internalGoogleAnalyticsId) {
          snAnalyticsService.getInternalId().then(({ data }) => {
            this.eventHelper(data?.analyticsId, group, eventName, label)
          })
        } else {
          this.eventHelper(this.$store.internalGoogleAnalyticsId, group, eventName, label)
        }
      }
    },
    eventHelper (id, group, eventName, label) {
      if (window.ga) {
        if (label !== '') {
          window.ga(`${id}.send`, 'event', group, eventName, label)
        } else {
          window.ga(`${id}.send`, 'event', group, eventName)
        }
      }
    }
  }
}
